<template>
  <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMinYMin meet" viewBox="0 0 24 24">
    <g>
      <path
        d="m 10.672476,6.8235409 q 0,-0.5787749 0.405143,-0.9921855 0.41341,-0.4134107 0.992185,-0.4134107 0.587043,0 0.992186,0.4134107 0.405142,0.4134106 0.405142,0.9921855 0,0.5787749 -0.41341,0.9921856 -0.405143,0.4051424 -0.983918,0.4051424 -0.570506,0 -0.983917,-0.4134107 Q 10.672476,7.3940476 10.672476,6.8235409 Z M 9.5479994,10.965916 V 9.1138359 h 3.7703056 v 6.1598181 h 1.190622 v 1.843812 H 9.5479994 v -1.843812 h 1.2154276 v -4.307738 z"
        style="font-family:Rockwell;-inkscape-font-specification:'Rockwell Bold';fill:#101e4c;fill-opacity:1"
        id="path2510" />
      <circle style="fill:none;fill-opacity:1;stroke:#00508c;stroke-width:2.5;stroke-dasharray:none;stroke-opacity:1"
        id="path3589" cx="11.815307" cy="11.848036" r="10.5" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'InfoIcon'
}
</script>
